import { useEffect, useState } from "react"
import Send from "../../communication"
import { useScope } from "../../../container/SelectProjectCompanyContainer"

export const useTags = () => {
  const [tags, setTags] = useState([])
  const [reloadTags, setReloadTags] = useState(false)

  useEffect(() => {
    Send.get("/tags").then((tags) => {
      setTags(tags)
    })
  }, [reloadTags])

  return [tags, setReloadTags, reloadTags]
}

export const useTagsByProject = () => {

  const { scope, scopeType } = useScope()
  const [tags, setTags] = useState([])

  const loadDataTags = async () => {
    const tagsResponse = await Send.get(`/tags/project/${scope?.id}`, `scopeType=${scopeType}`)

    setTags(tagsResponse)
  }

  useEffect(() => {
    loadDataTags()
  }, [scope && scope?.id])

  return { tags }
}

export const useAssistanceTags = () => {
  const { scope, scopeType } = useScope();
  const [tags, setTags] = useState([]);
  const [tagsOptions, setTagsOptions] = useState([]);
  const [reloadTags, setReloadTags] = useState(false);

  useEffect(() => {
    if(scope?.id || reloadTags) {
      Send.get(`/tags-assistance/project/${scope?.id}`, `scopeType=${scopeType}`).then((tags) => {
        setTags(Array.isArray(tags) ? tags : []);
        setTagsOptions(Array.isArray(tags) ? tags.map(row => ({ label: row?.name, value: row?.id })) : []);
        setReloadTags(false);
      });
    }
  }, [reloadTags, scope]);

  return { tags, tagsOptions, setReloadTags, reloadTags };
}
